import React from "react"

import { Box, HStack, Icon, Pressable, Text, VStack } from "wealthmode-frontend/gluestack/ui"
import { ChevronLeftIcon, ChevronRightIcon, XIcon } from "wealthmode-frontend/icons"

import Logo from "~/assets/brand/logo.svg"

import navigation from "@/_nav"
import { AppSidebarNav } from "@/components/AppSidebarNav"
import {
  APP_HEADER_HEIGHT_CLASS,
  SIDEBAR_INSET_CLASS,
  SIDEBAR_WIDTH_COLLAPSED,
  SIDEBAR_WIDTH_EXPANDED,
  useSidebar,
} from "@/context"

const AppSidebar = () => {
  const { sidebarShow, setSidebarShow, sidebarUnfoldable, toggleUnfoldable } = useSidebar()

  if (!sidebarShow) {
    return null
  }

  const collapsed = sidebarUnfoldable

  return (
    <Box
      className="fixed left-0 top-0 bottom-0 border-r border-border-medium z-[999] flex flex-col bg-background-primary"
      style={{
        width: collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED,
        display: sidebarShow ? "flex" : "none",
      }}
    >
      <VStack className="flex-1">
        <HStack
          className={`${APP_HEADER_HEIGHT_CLASS} shrink-0 border-b border-border-medium items-center ${SIDEBAR_INSET_CLASS} ${
            collapsed ? "justify-center" : "justify-between"
          }`}
        >
          <a
            href="/"
            className="flex items-center gap-3"
          >
            {/* The mark is 2:1, so height follows from the width. Collapsed matches
                the 24px nav icon slot so the logo sits on the same centre line. */}
            <Logo
              width={collapsed ? 24 : 36}
              height={collapsed ? 12 : 18}
            />
            {collapsed ? null : (
              <Text className="text-lg font-semibold text-foreground-primary tracking-tight">Wealthmode</Text>
            )}
          </a>
          <Pressable
            className="lg:hidden"
            onPress={() => setSidebarShow(false)}
          >
            <Icon
              as={XIcon}
              className="text-foreground-primary h-10 w-10"
            />
          </Pressable>
        </HStack>
        <Box className="flex-1 overflow-hidden overflow-x-hidden">
          <AppSidebarNav items={navigation} />
        </Box>
        <HStack
          className={`${APP_HEADER_HEIGHT_CLASS} shrink-0 border-t border-border-medium hidden lg:flex items-center ${SIDEBAR_INSET_CLASS} ${
            collapsed ? "justify-center" : "justify-end"
          }`}
        >
          <Pressable
            onPress={toggleUnfoldable}
            className="w-12 h-12 items-center justify-center rounded-[10px] transition-colors hover:bg-background-tertiary/60"
            accessibilityLabel={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <Icon
              as={collapsed ? ChevronRightIcon : ChevronLeftIcon}
              className="text-foreground-tertiary w-10 h-10"
            />
          </Pressable>
        </HStack>
      </VStack>
    </Box>
  )
}

export default React.memo(AppSidebar)
